<ng-template #template>
  <div role="button" class="svc-preview__test-again svc-btn" (click)="action.action()" [key2click]>
    <span class="svc-btn__text">
      {{action.title}}
    </span>
  </div>
</ng-template>